import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'VIAGEM_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('manutencaoForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/viagem/listarDashboard?viagem=true`);
    return {
        type: 'VIAGEM_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		console.log({
			...registro,
			datahora_agendamento: registro.datahora_agendamento ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_agendamento) : null,
			datahora_previsao_termino: registro.datahora_previsao_termino ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_previsao_termino) : null,
			datahora_inicio: registro.datahora_inicio ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_inicio) : null,
			datahora_fim: registro.datahora_fim ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_fim) : null
		});
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/manutencao`, {
				...registro,
				datahora_agendamento: registro.datahora_agendamento ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_agendamento) : null,
				datahora_previsao_termino: registro.datahora_previsao_termino ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_previsao_termino) : null,
				datahora_inicio: registro.datahora_inicio ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_inicio) : null,
				datahora_fim: registro.datahora_fim ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_fim) : null
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/manutencao`, {
				...registro,
				datahora_agendamento: registro.datahora_agendamento ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_agendamento) : null,
				datahora_previsao_termino: registro.datahora_previsao_termino ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_previsao_termino) : null,
				datahora_inicio: registro.datahora_inicio ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_inicio) : null,
				datahora_fim: registro.datahora_fim ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_fim) : null
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/manutencao?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
